/**
 * Build a GET path from a TanStack Query key. Only string segments are joined
 * — object filter bags must never become `/api/foo/[object Object]` (Express
 * would treat that as `/:id` and 404, e.g. Hub contacts list).
 */
export function queryKeyToPath(queryKey: readonly unknown[]): string {
  return queryKey.filter((k): k is string => typeof k === "string").join("/");
}
